export { default } from './ListItemText';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ListItemText/index.js
// module id = 836
// module chunks = 2